import type { ReactElement } from "react";

import type { Permission } from "@/types";
import type { AppRouteHandle, RouteSkeletonConfig } from "@/types/routeSkeleton";

/**
 * Builds a route object with `path`, `element`, and `handle: { skeleton }` for {@link PageSuspense}.
 */
export function skeletonRoute(options: {
  path: string;
  skeleton: RouteSkeletonConfig;
  permission?: Permission;
  element: ReactElement;
}): {
  path: string;
  handle: AppRouteHandle;
  element: ReactElement;
} {
  const { path, skeleton, permission, element } = options;
  return {
    path,
    handle: { skeleton, ...(permission ? { permission } : {}) },
    element,
  };
}
